let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1E1FB")).then(() => parcelRequire('lghrN'));